import type { ILanguageResources, ITranslationModule } from '../../../../interfaces';
import { interpolate } from '../../../../global';

// eslint-disable-next-line @typescript-eslint/no-extraneous-class
class Id {
  private constructor() {}

  public static readonly prefix = 'UI.scripts.dealer-franchisee.quotes.views.FranchiseeEngineeredToOrderView.';
  public static readonly close = `${Id.prefix}close`;
  public static readonly discard = `${Id.prefix}discard`;
  public static readonly discardChanges = `${Id.prefix}discardChanges`;
  public static readonly newSpecialItem = `${Id.prefix}newSpecialItem`;
  public static readonly specialItem = `${Id.prefix}specialItem`;

  // Added keys
  public static readonly title = `${Id.prefix}title`;
  public static readonly quantity = `${Id.prefix}quantity`;
  public static readonly supplierReference = `${Id.prefix}supplierReference`;
  public static readonly description = `${Id.prefix}description`;
  public static readonly supplierUnitPrice = `${Id.prefix}supplierUnitPrice`;
  public static readonly chooseFile = `${Id.prefix}chooseFile`;
  public static readonly supplierToUpload = `${Id.prefix}supplierToUpload`;
  public static readonly thumbnail = `${Id.prefix}thumbnail`;
  public static readonly notesToClient = `${Id.prefix}notesToClient`;
  public static readonly notesToManufacturer = `${Id.prefix}notesToManufacturer`;
  public static readonly thisDetailIsPublishedOnQuoteReports = `${Id.prefix}thisDetailIsPublishedOnQuoteReports`;
  public static readonly thisDetailIsPublishedOnPurchaseOrderReport = `${Id.prefix}thisDetailIsPublishedOnPurchaseOrderReport`;
  public static readonly comments = `${Id.prefix}comments`;
  public static readonly shopDrawing = `${Id.prefix}shopDrawing`;

  // Validation and workflow
  public static readonly specialItemReferenceMustBeSet = `${Id.prefix}specialItemReferenceMustBeSet`;
  public static readonly quantityMustBeValid = `${Id.prefix}quantityMustBeValid`;
  public static readonly quantityMustBeWholeNumber = `${Id.prefix}quantityMustBeWholeNumber`;
  public static readonly thumbnailMustBeUploaded = `${Id.prefix}thumbnailMustBeUploaded`;
  public static readonly shopDrawingFileMustBeIncluded = `${Id.prefix}shopDrawingFileMustBeIncluded`;
  public static readonly pleaseAddTitleToDescribeSpecialItem = `${Id.prefix}pleaseAddTitleToDescribeSpecialItem`;
  public static readonly pleaseProvideQuantityGreaterThanZero = `${Id.prefix}pleaseProvideQuantityGreaterThanZero`;
  public static readonly specialItemQuantityMustBeWholeNumber = `${Id.prefix}specialItemQuantityMustBeWholeNumber`;

  // Save workflow
  public static readonly gettingUpdatesFromSupplier = `${Id.prefix}gettingUpdatesFromSupplier`;
  public static readonly savingItemTitle = `${Id.prefix}savingItemTitle`;
  public static readonly requestingUpdatesFromSupplier = `${Id.prefix}requestingUpdatesFromSupplier`;
  public static readonly supplierProcessingCompleteSendingUpdatesToServer = `${Id.prefix}supplierProcessingCompleteSendingUpdatesToServer`;
  public static readonly saveCancelledCouldNotCommunicateWithServer = `${Id.prefix}saveCancelledCouldNotCommunicateWithServer`;

  // Add new key for 'Preparing to save'
  public static readonly preparingToSave = `${Id.prefix}preparingToSave`;

  // Conversation/notes
  public static readonly viewNote = `${Id.prefix}viewNote`;
  public static readonly addNote = `${Id.prefix}addNote`;
  public static readonly editNote = `${Id.prefix}editNote`;

  // Conversation headers
  public static readonly editDraftComments = `${Id.prefix}editDraftComments`;
  public static readonly editComments = `${Id.prefix}editComments`;
  public static readonly supportInitialTopic = `${Id.prefix}supportInitialTopic`;
  public static readonly addComments = `${Id.prefix}addComments`;

  // Tab navigation
  public static readonly optionsTab = `${Id.prefix}optionsTab`;
  public static readonly conversationTab = `${Id.prefix}conversationTab`;

  // Conversation validation
  public static readonly cancelEtoNotification = `${Id.prefix}cancelEtoNotification`;
  public static readonly continueSpecialItemBqsCancel = `${Id.prefix}continueSpecialItemBqsCancel`;
  public static readonly resolveEtoNotification = `${Id.prefix}resolveEtoNotification`;
  public static readonly specialItemValidationIssues = `${Id.prefix}specialItemValidationIssues`;
  public static readonly etoMissingSupportInitialTopicMsg = `${Id.prefix}etoMissingSupportInitialTopicMsg`;
}

// eslint-disable-next-line @typescript-eslint/no-extraneous-class
export class LangFranchiseeEngineeredToOrder {
  private constructor() {}

  public static close(): string {
    return interpolate(Id.close);
  }

  public static discard(): string {
    return interpolate(Id.discard);
  }

  public static discardChanges(): string {
    return interpolate(Id.discardChanges);
  }

  public static newSpecialItem(): string {
    return interpolate(Id.newSpecialItem);
  }

  public static specialItem(): string {
    return interpolate(Id.specialItem);
  }

  public static title(): string {
    return interpolate(Id.title);
  }

  public static quantity(): string {
    return interpolate(Id.quantity);
  }

  public static supplierReference(): string {
    return interpolate(Id.supplierReference);
  }
  public static description(): string {
    return interpolate(Id.description);
  }

  public static supplierUnitPrice(): string {
    return interpolate(Id.supplierUnitPrice);
  }

  public static chooseFile(): string {
    return interpolate(Id.chooseFile);
  }

  public static supplierToUpload(): string {
    return interpolate(Id.supplierToUpload);
  }

  public static thumbnail(): string {
    return interpolate(Id.thumbnail);
  }

  public static notesToClient(): string {
    return interpolate(Id.notesToClient);
  }

  public static notesToManufacturer(): string {
    return interpolate(Id.notesToManufacturer);
  }

  public static thisDetailIsPublishedOnQuoteReports(): string {
    return interpolate(Id.thisDetailIsPublishedOnQuoteReports);
  }

  public static thisDetailIsPublishedOnPurchaseOrderReport(): string {
    return interpolate(Id.thisDetailIsPublishedOnPurchaseOrderReport);
  }

  public static comments(): string {
    return interpolate(Id.comments);
  }

  public static shopDrawing(): string {
    return interpolate(Id.shopDrawing);
  }

  // Validation and workflow
  public static specialItemReferenceMustBeSet(): string {
    return interpolate(Id.specialItemReferenceMustBeSet);
  }

  public static quantityMustBeValid(): string {
    return interpolate(Id.quantityMustBeValid);
  }

  public static quantityMustBeWholeNumber(): string {
    return interpolate(Id.quantityMustBeWholeNumber);
  }

  public static thumbnailMustBeUploaded(): string {
    return interpolate(Id.thumbnailMustBeUploaded);
  }

  public static shopDrawingFileMustBeIncluded(): string {
    return interpolate(Id.shopDrawingFileMustBeIncluded);
  }

  public static pleaseAddTitleToDescribeSpecialItem(): string {
    return interpolate(Id.pleaseAddTitleToDescribeSpecialItem);
  }

  public static pleaseProvideQuantityGreaterThanZero(): string {
    return interpolate(Id.pleaseProvideQuantityGreaterThanZero);
  }

  public static specialItemQuantityMustBeWholeNumber(): string {
    return interpolate(Id.specialItemQuantityMustBeWholeNumber);
  }

  // Save workflow
  public static gettingUpdatesFromSupplier(): string {
    return interpolate(Id.gettingUpdatesFromSupplier);
  }

  public static savingItemTitle(args: { title: string }): string {
    return interpolate(Id.savingItemTitle, args);
  }

  public static requestingUpdatesFromSupplier(): string {
    return interpolate(Id.requestingUpdatesFromSupplier);
  }

  public static supplierProcessingCompleteSendingUpdatesToServer(): string {
    return interpolate(Id.supplierProcessingCompleteSendingUpdatesToServer);
  }

  public static saveCancelledCouldNotCommunicateWithServer(): string {
    return interpolate(Id.saveCancelledCouldNotCommunicateWithServer);
  }

  // Add new method for 'Preparing to save'
  public static preparingToSave(): string {
    return interpolate(Id.preparingToSave);
  }

  // Conversation/notes
  public static viewNote(): string {
    return interpolate(Id.viewNote);
  }

  public static addNote(): string {
    return interpolate(Id.addNote);
  }

  public static editNote(): string {
    return interpolate(Id.editNote);
  }

  // Conversation headers
  public static editDraftComments(): string {
    return interpolate(Id.editDraftComments);
  }

  public static editComments(): string {
    return interpolate(Id.editComments);
  }

  public static supportInitialTopic(): string {
    return interpolate(Id.supportInitialTopic);
  }

  public static addComments(): string {
    return interpolate(Id.addComments);
  }

  // Tab navigation
  public static optionsTab(): string {
    return interpolate(Id.optionsTab);
  }

  public static conversationTab(): string {
    return interpolate(Id.conversationTab);
  }

  // Conversation validation
  public static cancelEtoNotification(): string {
    return interpolate(Id.cancelEtoNotification);
  }

  public static continueSpecialItemBqsCancel(): string {
    return interpolate(Id.continueSpecialItemBqsCancel);
  }

  public static resolveEtoNotification(args: { issues: string }): string {
    return interpolate(Id.resolveEtoNotification, args);
  }

  public static specialItemValidationIssues(): string {
    return interpolate(Id.specialItemValidationIssues);
  }

  public static etoMissingSupportInitialTopicMsg(supplierName: string): string {
    return interpolate(Id.etoMissingSupportInitialTopicMsg, { supplierName });
  }
}

export class FranchiseeEngineeredToOrderViewModule implements ITranslationModule {
  registerItems(register: ILanguageResources) {
    register.add(Id.close, 'Close', 'Button label for closing the dialog');
    register.add(Id.discard, 'Discard', 'Button label for discarding a new item');
    register.add(Id.discardChanges, 'Discard Changes', 'Button label for discarding changes to an existing item');
    register.add(Id.newSpecialItem, "New {{glossary 'special-item'}}", 'Default title for a new special item');
    register.add(Id.specialItem, "{{glossary 'special-item'}}", 'Default fallback title for a special item');
    register.add(Id.title, 'Title', 'Label for special item title');
    register.add(Id.quantity, 'Quantity', 'Label for special item quantity');
    register.add(Id.supplierReference, "{{glossary 'supplier'}} Reference", 'Label for supplier reference');
    register.add(Id.supplierUnitPrice, "{{glossary 'supplier'}} Unit Price", 'Label for supplier unit price');
    register.add(Id.chooseFile, 'Choose file', 'Button label for choosing a file');
    register.add(Id.supplierToUpload, "{{glossary 'supplier'}} to upload", 'Label for supplier to upload file');
    register.add(Id.thumbnail, 'Thumbnail', 'Label for thumbnail image');
    register.add(Id.notesToClient, "Notes to {{glossary 'client'}}", 'Label for notes to client');
    register.add(Id.notesToManufacturer, 'Notes to Manufacturer', 'Label for notes to manufacturer');
    register.add(
      Id.thisDetailIsPublishedOnQuoteReports,
      "This detail is published on {{glossary 'quote'}} Reports.",
      'Tooltip for notes to client'
    );
    register.add(
      Id.thisDetailIsPublishedOnPurchaseOrderReport,
      "This detail is published on the {{glossary 'purchase-order'}} report and is added to V6 when the {{glossary 'purchase-order'}} is issued.",
      'Tooltip for notes to manufacturer'
    );
    register.add(Id.comments, 'Comments', 'Label for comments section');
    register.add(Id.shopDrawing, 'Shop Drawing', 'Label for shop drawing file upload');

    // Validation and workflow
    register.add(
      Id.specialItemReferenceMustBeSet,
      "{{glossary 'special-item'}} Reference must be set",
      'Validation: special item reference required'
    );
    register.add(Id.quantityMustBeValid, 'Quantity must be valid', 'Validation: quantity must be valid');
    register.add(
      Id.quantityMustBeWholeNumber,
      'Quantity must be valid whole number',
      'Validation: quantity must be a whole number'
    );
    register.add(Id.thumbnailMustBeUploaded, 'Thumbnail must be uploaded', 'Validation: thumbnail required');
    register.add(
      Id.shopDrawingFileMustBeIncluded,
      'Shop Drawing file must be included',
      'Validation: shop drawing file required'
    );
    register.add(
      Id.pleaseAddTitleToDescribeSpecialItem,
      "Please add a title to describe this {{glossary 'special-item'}}",
      'Validation: title required'
    );
    register.add(
      Id.pleaseProvideQuantityGreaterThanZero,
      'Please provide a quantity greater than 0',
      'Validation: quantity > 0'
    );
    register.add(
      Id.specialItemQuantityMustBeWholeNumber,
      "{{glossary 'special-item'}} Quantity must be a whole number",
      'Validation: quantity must be a whole number'
    );

    // Save workflow
    register.add(
      Id.gettingUpdatesFromSupplier,
      "Getting updates from {{glossary 'supplier'}}",
      'Info: getting updates from supplier'
    );
    register.add(Id.savingItemTitle, 'Saving {{title}}', 'Info: saving item with title');
    register.add(
      Id.requestingUpdatesFromSupplier,
      "Requesting Updates from {{glossary 'supplier'}}",
      'Info: requesting updates from supplier'
    );
    register.add(
      Id.supplierProcessingCompleteSendingUpdatesToServer,
      "{{glossary 'supplier'}} processing complete. Sending updates to server",
      'Info: supplier processing complete'
    );
    register.add(
      Id.saveCancelledCouldNotCommunicateWithServer,
      'Save cancelled, could not communicate with Server',
      'Info: save cancelled'
    );

    // Register new string for 'Preparing to save'
    register.add(Id.preparingToSave, 'Preparing to save', 'Header for preparing to save');

    // Conversation/notes
    register.add(Id.viewNote, 'View Note', 'Button label for viewing a note');
    register.add(Id.addNote, 'Add Note', 'Button label for adding a note');
    register.add(Id.editNote, 'Edit Note', 'Button label for editing a note');

    // Conversation headers
    register.add(Id.editDraftComments, 'Edit Draft Comments', 'Header for editing draft comments');
    register.add(Id.editComments, 'Edit Comments', 'Header for editing comments');
    register.add(Id.supportInitialTopic, "{{glossary 'support-initial-topic'}}", 'Header for support initial topic');
    register.add(Id.addComments, 'Add Comments', 'Header for adding comments');

    // Tab navigation
    register.add(Id.optionsTab, 'Options', 'Tab label for options/settings view');
    register.add(Id.conversationTab, 'Conversation', 'Tab label for conversation view');

    // Conversation validation
    register.add(
      Id.cancelEtoNotification,
      "Cancellation\n\nThis does not delete the {{glossary 'special-item'}} from the {{glossary 'quote'}}. If you wish to do so you must delete the {{glossary 'special-item'}} manually. Deleting the {{glossary 'special-item'}} will not delete the associated {{glossary 'support-request'}} but it cannot be relinked. You may {{glossary 'bqs-reactivate'}} at any time.",
      'Notification for cancelling ETO'
    );
    register.add(
      Id.continueSpecialItemBqsCancel,
      "Continue {{glossary 'special-item'}} {{glossary 'bqs-cancel'}}",
      'Button label for continuing special item BQS cancel'
    );
    register.add(
      Id.resolveEtoNotification,
      "Validation Issues\n\nPlease correct the following issues before resolving this {{glossary 'special-item'}}:\n\n{{issues}}",
      'Notification for resolving ETO with issues'
    );
    register.add(
      Id.specialItemValidationIssues,
      "{{glossary 'special-item'}} Validation Issues",
      'Header for special item validation issues'
    );
    register.add(
      Id.etoMissingSupportInitialTopicMsg,
      "Please provide a detailed {{glossary 'support-initial-topic'}} before submitting this ticket to {{supplierName}}",
      'Validation: missing support initial topic'
    );
    register.add(Id.description, 'Description', 'Label for special item description');
  }
}
